/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { OrganizationSizeResponse } from './platformapi.schemas';

import getOrganizationSizesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of organization sizes
 * @summary Get Organization Sizes
 */
export const getOrganizationSizes = (signal?: AbortSignal) => {
  return getOrganizationSizesMutator<OrganizationSizeResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/organization-sizes/`,
    method: 'GET',
    signal,
  });
};

export const getGetOrganizationSizesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/organization-sizes/`] as const;
};

export const getGetOrganizationSizesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizationSizes>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSizes>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationSizesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationSizes>>> = ({ signal }) =>
    getOrganizationSizes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizationSizes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationSizesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizationSizes>>
>;
export type GetOrganizationSizesQueryError = void;

export function useGetOrganizationSizes<
  TData = Awaited<ReturnType<typeof getOrganizationSizes>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSizes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSizes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSizes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSizes<
  TData = Awaited<ReturnType<typeof getOrganizationSizes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSizes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationSizes>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationSizes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOrganizationSizes<
  TData = Awaited<ReturnType<typeof getOrganizationSizes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSizes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Organization Sizes
 */

export function useGetOrganizationSizes<
  TData = Awaited<ReturnType<typeof getOrganizationSizes>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrganizationSizes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOrganizationSizesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
